module.exports = __webpack_public_path__ + "static/media/16UNODC17.9b0b2808.jpg";